<script>
	export let children = [];
	let initialized = false;
	let elements = [];
	let prevArrow, nextArrow;
	let arrowTop = 100;

	import { onMount } from "svelte";
	import { Swiper, SwiperSlide } from "swiper/svelte";
	import { Navigation, Controller } from "swiper";

	// Import Swiper styles
	import "swiper/css";

	import "swiper/css/navigation";

	let controlledSwiper = null;
	
	const setControlledSwiper = (e) => {
      const [swiper] = e.detail;
      // set Controller swiper instance
      setTimeout(() => {
        controlledSwiper = swiper;
      });
    };

	onMount((x) => {
		elements = children
			? Array.from(children).map((c, i) => ({ el: c, id: i }))
			: [];
		initialized = true;
	});

	$: if(controlledSwiper) {
		const [imgHeight] = controlledSwiper.slidesSizesGrid;
		arrowTop = (imgHeight / 2) - 25;
	}
</script>

<div class="carousel-container">
	<span class="prev-arrow" >
		<svg style="{`top: ${arrowTop}px`}" bind:this={prevArrow} viewBox="0 0 26.061 50.707"
		><path
		style="fill:none;stroke:#707070;"
		d="M-317.677,969l-25,25,25,25"
		transform="translate(343.384 -968.651)"
		/></svg>
	</span>
	{#if initialized}
		<Swiper
			style="--swiper-navigation-color: #fff;--swiper-pagination-color: #fff"
			slidesPerView={1}
			spaceBetween={10}
			on:swiper={setControlledSwiper}
			breakpoints={{
				"280": {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				"768": {
					slidesPerView: 3,
					spaceBetween: 40,
				},
				"1024": {
					slidesPerView: 4,
					spaceBetween: 50,
				},
			}}
			modules={[Navigation, Controller]}
			navigation={{
				nextEl: nextArrow,
				prevEl: prevArrow,
			}}
			loop={true}
		>
			<!-- <span slot="container-end">Container End</span>
		<span slot="wrapper-end">Wrapper End</span> -->
			{#each elements as element, index (element.id)}
				<SwiperSlide >
					{@html element.el}
				</SwiperSlide>
			{/each}
		</Swiper>
	{/if}
	<span class="next-arrow" >
		<svg style="{`top: ${arrowTop}px`}" bind:this={nextArrow} viewBox="0 0 26.061 50.707"
		><path
		style="fill:none;stroke:#707070;"
		d="M-342.677,969l25,25-25,25"
		transform="translate(343.031 -968.651)"
		/></svg>
	</span>
</div>
<style>
	.carousel-container {
		width: 100%;
		margin: 0;
		display: flex;
		position: relative;
	}

	.prev-arrow {
		right: calc(100% + 10px);
	}
	.next-arrow {
		left: calc(100% + 10px);
	}
	.prev-arrow, .next-arrow {
		position: absolute;
		top: 0;
		height: 100%;
		/* display: flex;
		align-items: center; */
	}
	.prev-arrow svg, .next-arrow svg {
		width: 26px;
		position: relative;
		cursor: pointer;
	}
	@media screen and (max-width: 750px) {
		.prev-arrow svg, .next-arrow svg {
			width: 16px;
		}
	}
</style>